import whyChooseData from "../data/whyChooseData";

function WhyChoose() {
  return (
    <section className="whyus">

      <div className="container">

        <div className="row">

          <div className="col-12">

            <h2>
              Why Choose us?
            </h2>

            <p className="headText">
              Home Water Purifier Service Center RO Service Center stands out
              as one of the top water purifier RO service centers in the
              Hyderabad region due to a multitude of reasons despite the
              existence of several other similar service providers.
            </p>

          </div>

          {whyChooseData.map((item, index) => (
            <div
              className={
                index % 2 === 0
                  ? "col-md-5 offset-md-1"
                  : "col-md-6"
              }
              key={index}
            >
              <div className="subWhy wow animate__animated animate__fadeInUp">

                <span>

                  <img
                    src={item.image}
                    alt={item.title}
                    width="56"
                    height="56"
                  />

                </span>

                <p>

                  <b className="title-3">
                    {item.title}
                  </b>

                  <small>
                    {item.text}
                  </small>

                </p>

              </div>
            </div>
          ))}

        </div>

      </div>

    </section>
  );
}

export default WhyChoose;